import {NavigationButtonPosition, NavigationSectionType} from "../@const";
import NavigationSection from "../navigation-section"

// const debug = "navigation_autoHideOnScreenSize"
const debug = false

export default function navigation_autoHideOnScreenSize(spaceNeeded:number, paramName: 'height' | 'width' = 'height') {

    debug && console.log(debug, "run() spaceNeeded=", spaceNeeded, "paramName=", paramName)

    // reset is hidden to mode
    gd.navigationStructure.resetHiddenToMore()

    // logo 25 20 15
    // item = 38 + 8
    // separator = 10 *2 + 1

    const spaces = gd.spaces.navigationPanelTopSpacesAsNavigations
    // const spaces = _.filter(gd.spaces.navigationPanelSections, (navigationSection: NavigationSection) => {
    //     return navigationSection.position === NavigationButtonPosition.TOP
    // })

    const views = _.filter(gd.navigationStructure.views, (navigationSection: NavigationSection) => {
        return navigationSection.position === NavigationButtonPosition.TOP
    })

    const separator = {
        width   : 21,
        height  : 13,
    }

    let viewsSize = 0
    const sections = [...spaces, ...views].reverse()

    _(sections)
        .filter((section: NavigationSection)=>{
            return [
                NavigationSectionType.PERSONAL_VIEW,
                NavigationSectionType.CUSTOM_VIEW
            ].includes(section.type!)
        })
        .map((section: NavigationSection)=> {
            viewsSize += section[paramName]
        })

    _.map(sections, (section: NavigationSection)=>{
        debug && console.log(section.name, section[paramName], section.type, "missing = ", spaceNeeded)

        switch (section.type) {

            case NavigationSectionType.MORE:
                debug && console.log("    -> visible")
                section.hiddenToMore = false
                return;

            case NavigationSectionType.WORKSPACE:
            case NavigationSectionType.PERSONAL_VIEW:
            case NavigationSectionType.CUSTOM_VIEW:
            case NavigationSectionType.SEPARATOR:
            case NavigationSectionType.CHATS:
            case NavigationSectionType.USERS:
            case NavigationSectionType.TOOLS:
            case NavigationSectionType.REPORTS:
            case NavigationSectionType.AI_CHAT:
            case NavigationSectionType.CRM:
            case NavigationSectionType.SETTINGS:
            case NavigationSectionType.ATTENDANCE:
            default:

                if (spaceNeeded > 0) {
                    debug && console.log("    -> hiddenToMore = true")
                    section.hiddenToMore = true

                    // check if all views are hidden to more
                    if([
                        NavigationSectionType.PERSONAL_VIEW,
                        NavigationSectionType.CUSTOM_VIEW
                    ].includes(section.type!)) {
                        viewsSize -= section[paramName]

                        // if all views are hidden, then second separator is hidden too
                        if (viewsSize <= 0) {
                            spaceNeeded = spaceNeeded - separator[paramName]
                        }
                    }

                    // adjust space needed
                    spaceNeeded = spaceNeeded - section[paramName]
                    if (spaceNeeded < 0) spaceNeeded = 0

                    // console.log("hide", section.name, spaceNeeded)
                } else {
                    // debug && console.log("    -> visible")
                    section.hiddenToMore = false
                }

                break

            // default:
            //     debug && console.log("    type=?????? -> notHidden", section.type)
            //     section.hiddenToMore = false
            //     break
        }
    })

    // navigationStructure.debug()

}
